import * as requestFromServer from "./programReportCrud";
import { superAdminProgramReportSlice, callTypes } from "./programReportSlice";
import { actions as auth } from "../../../Auth/_redux/authRedux";
import { toastOption } from "../../../../../_metronic/_helpers/ToastHelpers";
import { toast } from "react-toastify";

const { actions } = superAdminProgramReportSlice;

export const fetchProgramReports = queryParams => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .findProgramReport(queryParams)
    .then(response => {
      const { data: { data: { total_items, items } = {} } = {} } = response;

      dispatch(actions.programReportsFetched({ total_items, items }));
    })
    .catch(error => {
      if (error.response.status === 401) {
        toast.error(error.response.data.message, toastOption);
        dispatch(auth.logout());
      }
      error = error.response.data.message;
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};
